/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {IpRange} from '../models/IpRange';

export interface GetAccountIpRanges$Request {
    accountId: number;
}

export interface GetAccountIpRanges$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountIpRangesRequest = createAction<PayloadData<void, GetAccountIpRanges$Request>>('GET_ACCOUNT_IP_RANGES__GET_ACCOUNT_IP_RANGES__REQUEST');
export const getAccountIpRangesSuccess = createAction<PayloadData<Array<IpRange>, GetAccountIpRanges$Request>>('GET_ACCOUNT_IP_RANGES__GET_ACCOUNT_IP_RANGES__SUCCESS');
export const getAccountIpRangesFailure = createAction<PayloadData<Error, GetAccountIpRanges$Request, true>>('GET_ACCOUNT_IP_RANGES__GET_ACCOUNT_IP_RANGES__FAILURE');

export const getAccountIpRangesActions = [
    getAccountIpRangesRequest,
    getAccountIpRangesSuccess,
    getAccountIpRangesFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountIpRanges = (meta: GetAccountIpRanges$Request, config?: GetAccountIpRanges$Config) => {
    return {
        CALL_API: {
            types: getAccountIpRangesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}/ip-ranges`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

